var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('div',{staticClass:"video-block"},[(_vm.embedded)?_c('div',{staticClass:"embedded",domProps:{"innerHTML":_vm._s(_vm.embedded)}}):_vm._e(),(_vm.block.meta.transcript)?_c('MediaTranscript',{attrs:{"text":_vm.block.meta.transcript}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }